
  // Google's first thumbnail of a just-made document is often an
  // unfinished render: 30 seconds after the page shows it, ask the
  // server for a fresh one. The server renders data-delay-ms only for a
  // document made in the last two minutes; the card and the table view
  // both run this, and the server ignores the second request.
  export default {
    mounted() {
      const delay = parseInt(this.el.dataset.delayMs, 10)
      if (Number.isNaN(delay)) return
      this.timer = setTimeout(() => {
        this.pushEvent("doc_thumb_refresh", {id: this.el.dataset.docId, auto: true})
      }, delay)
    },
    destroyed() { clearTimeout(this.timer) }
  }
